import {Component} from '@angular/core';

@Component({
  selector: 'gt-service-providers',
  templateUrl: './service-providers.component.html',
  styleUrls: ['./service-providers.component.scss']
})
export class ServiceProvidersComponent {}
